module.exports = __webpack_public_path__ + "img/exclamation-triangle-fill-yellow.f2f3e34a.svg";